<template>
  <div
    v-if="customerIsEligibleForFreeGift && initialSelectedFreeGiftProduct && selectedFreeGiftProduct"
    class="free-gift-promo"
    :class="`free-gift-promo--${ freeGiftSelectionType }`"
  >
    <div class="free-gift-promo__summary flex items-center justify-between">
      <div
        v-if="!sideCartItem || (freeGiftSelectionType != 'collection' || hideDropdown)"
        class="free-gift-promo__image"
        :class="{ 'free-gift-promo__image--png': selectedFreeGiftProduct?.image?.includes('.png') }"
      >
        <img
          :src="selectedFreeGiftProduct.image"
          alt="free-gift-image"
          width="52"
          height="44"
        >
      </div>
      <div class="free-gift-promo__summary-text uppercase">
        <h3 class="free-gift-promo__title font-medium xs">
          {{ freeGift.text }}
        </h3>
        <h4 class="free-gift-promo__product-title xs">
          {{ selectedFreeGiftProduct.title }}
        </h4>
      </div>

      <v-select
        v-if="!sideCartItem && (freeGiftSelectionType === 'collection' && !hideDropdown)"
        v-model="selectedFreeGiftProduct"
        :options="collectionProducts"
        :clearable="false"
        :searchable="false"
        class="free-gift-promo__dropdown"
      >
        <template #selected-option="option">
          <div class="free-gift-promo__dropdown-selected flex items-center sm font-semibold capitalize">
            <div class="free-gift-promo__dropdown-image">
              <img
                :src="option.dropdownImage"
                width="30"
                height="30"
                class="w-full h-full object-contain"
              >
            </div>
            {{ option.title.toLowerCase() }}
            <ChevronRightIcon class="ml-auto" />
          </div>
        </template>

        <template #option="option">
          <div class="free-gift-promo__dropdown-item flex items-center xs capitalize">
            <div class="free-gift-promo__dropdown-image">
              <img
                :src="option.dropdownImage"
                width="30"
                height="30"
                class="w-full h-full object-contain"
              >
            </div>
            {{ option.title.toLowerCase() }}
          </div>
        </template>
      </v-select>


      <button
        v-if="cartContainsFreeGift"
        class="cart-item__delete ml-auto pl-2"
        @click="removeItemFromCart"
      >
        {{ strings.remove }}
        <DeleteIcon />
      </button>
      <button
        v-else
        class="cart-item__redeem ml-auto btn btn--black"
        @click="addItemToCart"
      >
        Redeem
        <!-- <GiftIcon /> -->
      </button>
    </div>
    <v-select
      v-if="sideCartItem && (freeGiftSelectionType === 'collection' && !hideDropdown)"
      v-model="selectedFreeGiftProduct"
      :options="collectionProducts"
      :clearable="false"
      :searchable="false"
      class="free-gift-promo__dropdown"
    >
      <template #selected-option="option">
        <div class="free-gift-promo__dropdown-selected flex items-center sm font-semibold capitalize">
          <div class="free-gift-promo__dropdown-image">
            <img
              :src="option.dropdownImage"
              width="30"
              height="30"
              class="w-full h-full object-contain"
            >
          </div>
          {{ option.title.toLowerCase() }}
          <ChevronRightIcon class="ml-auto" />
        </div>
      </template>

      <template #option="option">
        <div class="free-gift-promo__dropdown-item flex items-center xs capitalize">
          <div class="free-gift-promo__dropdown-image">
            <img
              :src="option.dropdownImage"
              width="30"
              height="30"
              class="w-full h-full object-contain"
            >
          </div>
          {{ option.title.toLowerCase() }}
        </div>
      </template>
    </v-select>
  </div>
</template>

<script>
import { useCartStore } from '../../pinia/CartStore'
import { mapState, mapActions } from 'pinia'

import DeleteIcon from '../../icons/delete-icon'
import ChevronRightIcon from '../../icons/chevron-right'
// import GiftIcon from '../../icons/gift-icon'

export default {
  components: {
    DeleteIcon,
    ChevronRightIcon,
    // GiftIcon
  },
  props: {
    cartTotalPrice: {
      type: Number,
      default: 0
    },
    sideCartItem: {
      type: Boolean,
      default: true
    },
  },
  data () {
    return {
      strings: { ...window.theme.cart.strings },
      freeGift: { ...window.theme.cart.freeGift },
      initialSelectedFreeGiftProduct: window.theme.cart.freeGift.collectionProducts.find(product => product.available) ?? null,
      selectedFreeGiftProduct: window.theme.cart.freeGift.collectionProducts.find(product => product.available) ?? null
    }
  },
  computed: {
    ...mapState (useCartStore, [
      'cartContainsFreeGift',
      'freeGiftItem',
      'cartContainsNoneExcemptItems'
    ]),

    collectionProducts () {
      return this.freeGift.collectionProducts.filter(product => product.available)
    },
    freeGiftThreshold () {
      return this.freeGift.threshold * 100
    },
    customerIsEligibleForFreeGift () {
      return this.cartContainsNoneExcemptItems && this.cartTotalPrice >= this.freeGiftThreshold
    },
    selectedFreeGiftProductHasVariants () {
      return this.selectedFreeGiftProduct?.variants?.length > 1
    },
    freeGiftSelectionType () {
      let selectionType = 'fixed-item'
      if (this.collectionProducts.length > 1) {
        selectionType = 'collection'
      } else if (this.selectedFreeGiftProductHasVariants) {
        selectionType = 'variant-item'
      }
      return selectionType
    },
    hideDropdown () {
      return this.cartContainsFreeGift
    },
    payload () {
      return {
        items: [
          {
            id: this.selectedFreeGiftProduct.variants[0].id,
            quantity: 1
          }
        ]
      }
    },
    matchingSelectedCartItemProduct () {
      return this.collectionProducts.find(product => product.handle === this.freeGiftItem.handle)
    }
  },
  watch: {
    'freeGiftItem.handle': function (newHandle, oldHandle) {
      this.setSelectedCartItem()
    }
  },
  mounted () {
    this.setSelectedCartItem()
    console.log(this.selectedFreeGiftProduct)
  },
  methods: {
    ...mapActions(useCartStore, [
      'addItems',
      'removeItem'
    ]),
    async addItemToCart () {
      await this.addItems(this.payload)
    },
    async removeItemFromCart () {
      await this.removeItem(this.freeGiftItem.key)
    },
    setSelectedCartItem () {
      if (this.cartContainsFreeGift) {
        this.selectedFreeGiftProduct = this.matchingSelectedCartItemProduct
      } else {
        this.selectedFreeGiftProduct = this.initialSelectedFreeGiftProduct
      }
    }
  },
}
</script>
